import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsFacet, ConvertedComponentData, TextInput } from '../../../types'
import {
  CmsConverterService,
  defaultFSFacet,
  defaultTextInput
} from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ProductFinderAnswerTileOptionConverter extends CmsConverterService<ProductFinderAnswerTileOptionData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      facetName: formData.st_headline ?? defaultTextInput,
      facet: formData.pt_tag[0] ?? defaultFSFacet,
    }
  }
}

export const PRODUCT_FINDER_ANSWER_TILE_OPTION_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ProductFinderAnswerTileOptionData>>('ProductFinderAnswerTileOptionConverter')

export interface ProductFinderAnswerTileOptionData extends ConvertedComponentData {
  facetName: TextInput;
  facet: CmsFacet;
}
